/* 48 Banners — The Collection : filtres + recherche + voir plus + lightbox */
(function () {
  "use strict";
  const INITIAL = 18;
  const grid    = document.getElementById("tc-grid");
  if (!grid) return;

  const cards   = Array.from(grid.querySelectorAll(".tc-card"));
  const filters = Array.from(document.querySelectorAll(".tc-filter"));
  const search  = document.getElementById("tc-search");
  const loadBtn = document.getElementById("tc-loadmore");
  const moreWrap = loadBtn ? loadBtn.parentElement : null;
  const empty   = document.getElementById("tc-empty");

  let category = "all";
  let query    = "";
  let expanded = false;
  let visible  = [];

  const norm = (s) =>
    (s || "").normalize("NFD").replace(/[̀-ͯ]/g, "").toLowerCase().trim();

  function matches(card) {
    const okCat = category === "all" || card.dataset.continent === category;
    const okQ   = query === "" || norm(card.dataset.display).includes(query);
    return okCat && okQ;
  }

  function apply() {
    const filtering = category !== "all" || query !== "";
    const matched   = cards.filter(matches);
    const limit     = filtering || expanded ? matched.length : INITIAL;
    visible = [];
    let shown = 0;
    cards.forEach((card) => {
      const ok = matched.includes(card) && shown < limit;
      card.classList.toggle("is-hidden", !ok);
      if (ok) { visible.push(card); shown++; }
    });
    if (empty) empty.style.display = matched.length === 0 ? "block" : "none";
    if (moreWrap) moreWrap.style.display = (!filtering && !expanded && matched.length > INITIAL) ? "" : "none";
  }

  filters.forEach((btn) => {
    btn.addEventListener("click", () => {
      filters.forEach((b) => b.classList.remove("is-active"));
      btn.classList.add("is-active");
      category = btn.dataset.filter;
      expanded = false;
      apply();
    });
  });

  if (search) search.addEventListener("input", () => { query = norm(search.value); apply(); });
  if (loadBtn) loadBtn.addEventListener("click", () => { expanded = true; apply(); });

  /* ---- Lightbox ---- */
  const lb      = document.getElementById("tc-lightbox");
  if (!lb) { apply(); return; }

  const lbMedia = document.getElementById("tc-lb-media");
  const lbNum   = document.getElementById("tc-lb-num");
  const lbName  = document.getElementById("tc-lb-name");
  const lbShop  = document.getElementById("tc-lb-shop");
  let current   = -1;

  function renderLightbox(card) {
    const name  = card.dataset.display;
    const num   = card.dataset.n;
    const img   = card.dataset.img;
    const ph    = card.dataset.ph;
    const tint  = card.style.getPropertyValue("--pbg");
    const avail = card.dataset.available;
    const slug  = card.dataset.name;

    lbNum.textContent  = num;
    lbName.textContent = name;

    if (img && !ph) {
      lbMedia.innerHTML = '<img src="' + img + '" alt="' + name + ' 2026 — 48 Banners" loading="lazy">';
    } else {
      lbMedia.innerHTML =
        '<div class="tc-lb-ph" style="--pbg:' + tint + '"><span>' + name +
        '</span><small>2026</small><em>coming soon</em></div>';
    }

    if (lbShop) {
      if (avail) {
        lbShop.setAttribute("href", "/products/" + slug + "-2026");
        lbShop.innerHTML = 'View product <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M5 12h14m-6-6 6 6-6 6"/></svg>';
        lbShop.style.opacity = "";
        lbShop.style.pointerEvents = "";
        lbShop.style.cursor = "";
      } else {
        lbShop.removeAttribute("href");
        lbShop.innerHTML = 'Coming soon';
        lbShop.style.opacity = "0.45";
        lbShop.style.pointerEvents = "none";
        lbShop.style.cursor = "default";
      }
    }
  }

  function openAt(card) {
    current = visible.indexOf(card);
    if (current === -1) return;
    renderLightbox(card);
    lb.classList.add("is-open");
    document.body.style.overflow = "hidden";
  }
  function close() {
    lb.classList.remove("is-open");
    document.body.style.overflow = "";
    current = -1;
  }
  function step(dir) {
    if (current === -1 || visible.length === 0) return;
    current = (current + dir + visible.length) % visible.length;
    renderLightbox(visible[current]);
  }

  cards.forEach((card) => card.addEventListener("click", () => openAt(card)));
  document.getElementById("tc-lb-close").addEventListener("click", close);
  document.getElementById("tc-lb-prev").addEventListener("click", () => step(-1));
  document.getElementById("tc-lb-next").addEventListener("click", () => step(1));
  lb.addEventListener("click", (e) => { if (e.target === lb) close(); });
  document.addEventListener("keydown", (e) => {
    if (!lb.classList.contains("is-open")) return;
    if (e.key === "Escape") close();
    else if (e.key === "ArrowLeft") step(-1);
    else if (e.key === "ArrowRight") step(1);
  });

  apply();
})();
